import ResultType from "./ResultType.js";

const ResultDataNew = {
    Id: { key: 'id', name: 'Result Id', type: 'NUMBER' },
    SessionId: { key: 'sessionID', name: 'Session Id', type: 'NUMBER' },
    PitcherId: { key: 'pitcherTagID', name: 'Pitcher Id', type: 'NUMBER' },
    BatterId: { key: 'batterTagID', name: 'Batter Id', type: 'NUMBER' },
    Type: { key: 'resultType', name: 'Result Type', type: 'STRING', enum: ResultType },
    CreateDate: { key: 'createDate', name: 'UTC Time', type: 'STRING' },
    IsInvalid: { key: 'isInvalid', name: 'UTC Time', type: 'BOOL' },
    PitchId: { key: 'pitchResultID', name: 'Related Pitch Id', type: 'NUMBER' },
    HitId: { key: 'hitResultID', name: 'Related Hit Id', type: 'NUMBER' },
    Data: { key: 'data', name: 'Data', type: 'OBJECT' },

    getDataPath(parameterKey, dataSection, resultType) {
        const targetPath = [this.Data.key];

        if (dataSection) {
            targetPath.push(dataSection);
        }

        if (resultType) {
            switch (resultType) {
                case ResultType.Pitch.key:
                    targetPath.push('pitch');
                    break;

                case ResultType.Hit.key:
                    targetPath.push('hit');
                    break;
            
                default:
                    targetPath.push(resultType);
                    break;
            }
        }

        if (parameterKey instanceof Array) {
            return targetPath.concat(parameterKey);
        }

        if (typeof(parameterKey) === 'string'){
            targetPath.push(parameterKey);
            return targetPath;
        }
        
        throw new Error("Only strings and arrays can be used as parameterKey");
    },
};

export default ResultDataNew;